import { compose, createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import createRootReducer from './reducers';
import { campaignEditingMiddleware, campaignEditingSyncMiddleware } from './middleware';
import { IS_LOCAL_DEV } from 'config/envVariable';

// 定義 persist 配置
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['firebase']
};

// 導出 persistor 實例供其他模組使用
let persistorInstance = null;

export const getPersistor = () => persistorInstance;

export default function initStore(initialState) {
    const middleware = [thunk, campaignEditingMiddleware, campaignEditingSyncMiddleware];
    const rootReducer = createRootReducer();
    const persistedReducer = persistReducer(persistConfig, rootReducer);
    const store = createStore(
        persistedReducer,
        initialState,
        compose(
            applyMiddleware(...middleware),
            window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
        )
    );

    //  處理熱更新 (Hot Module Replacement)
    if (IS_LOCAL_DEV && module.hot) {
        module.hot.accept('./reducers', () => {
            const nextReducer = createRootReducer(store.asyncReducers);
            // 建立一個持久化的 reducer
            const persistedReducer = persistReducer(persistConfig, nextReducer);
            store.replaceReducer(persistedReducer);
        });
    }

    // 處理了動態注入 Reducer
    store.asyncReducers = {};
    store.injectReducer = (key, reducer) => {
        store.asyncReducers[key] = reducer;
        const nextReducer = createRootReducer(store.asyncReducers);
        // 建立一個持久化的 reducer
        const persistedReducer = persistReducer(persistConfig, nextReducer);
        store.replaceReducer(persistedReducer);
    };
    // Remove reducer
    store.removeReducer = key => {
        delete store.asyncReducers[key];
        // Clean up state
        delete store.getState()[key];
        const nextReducer = createRootReducer(store.asyncReducers);
        // 重新包裹一次，確保持久化層還在
        const persistedReducer = persistReducer(persistConfig, nextReducer);
        store.replaceReducer(persistedReducer);
    };

    const persistor = persistStore(store);
    persistorInstance = persistor;

    return { store, persistor };
}
